import { render, staticRenderFns } from "./stocking.vue?vue&type=template&id=206678eb&"
import script from "./stocking.vue?vue&type=script&lang=js&"
export * from "./stocking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports